export const STAKE_TOKEN_ADDRESS = {
  veMODE: '0xDfc7C877a950e49D2610114102175A06C2e3167a',
  veBPT: '0x7c86a44778c52a0AAD17860924b53bf3f35Dc932',
} as const;

export const CLOCK_ADDRESSES = {
  veMODE: '0x66CC481755f8a9d415e75d29C17B0E3eF2Af70bD',
  veBPT: '0x6d1D6277fBB117d77782a85120796BCb08cAae8a',
} as const;

export const VOTING_ESCROW_ADDRESSES = {
  veMODE: '0xff8AB822b8A853b01F9a9E9465321d6Fe77c9D2F',
  veBPT: '0x9c2eFe2a1FBfb601125Bb07a3D5bC6EC91F91e01',
} as const;

export const VOTER_ADDRESSES = {
  veMODE: '0x71439Ae82068E19ea90e4F506c74936aE170Cf58',
  veBPT: '0x2aA8A5C1Af4EA11A1f1F10f3b73cfB30419F77Fb',
} as const;

export const WARMUP_PERIOD = 5 * 24 * 60 * 60;

export const DECIMALS = 18;
